import { Controller } from "@hotwired/stimulus"

let select2Loaded = false

export default class Select2Controller extends Controller {
  static targets = ["selectBackskin", 'selectAnalytics', 'moveFolder', 'selectInterest']
  static values = {
    frameId: { type: String }
  }
  selected = []

  async connect() {
    if ($(this.element).hasClass("select2-hidden-accessible")) {
      $(this.element).parent()?.find('.select2-container--default')?.remove()
    }
    await this.loadSelect2()
    this.initSelect2()
  }

  async loadSelect2() {
    if (select2Loaded) return

    const module = await import("select2")
    const select2 = module.default || module

    select2($)
    select2Loaded = true
  }

  initSelect2() {
    const $element = $(this.element);
    const $dropdownParent =
      this.hasFrameIdValue && this.frameIdValue.trim() !== ""
        ? this.element.closest(`${this.frameIdValue}`)
        : $element.parent()
    const dropdownOptions = {
      placeholder: this.hasSelectBackskinTarget ? "Select" : this.element.dataset.placeholder || "Search Interest",
      dropdownParent: $dropdownParent
    };
    if (this.element.dataset.closeOnSelect === "false") {
      dropdownOptions.closeOnSelect = false;
    }
    $element.select2(dropdownOptions)
      .on('select2:open', (e) => {
        const evt = "scroll.select2";
        $(e.target).parents().off(evt);
        $(globalThis).off(evt);
        const modalBody = $element.closest('.modal-body');
        if (modalBody.length) {
          modalBody.data('original-overflow', modalBody.css('overflow-y'));
          modalBody.css('overflow-y', 'hidden');
        }
        if (this.element.dataset.filterRemoved === 'true') {
          this.searchDisabled()
        }
        setTimeout(() => {
          const searchInput = document.querySelector('.select2-container--open .select2-search__field');
          // if (searchInput) searchInput.blur();

          // set placeholder in the languge select tag
          const placeholder = this.element.dataset.placeholder;
          if (placeholder && this.element.id === 'custom_lang') {
            searchInput.placeholder = placeholder;
          }
        }, 0);
      })
      .on('select2:close', (e) => {
        const modalBody = $element.closest('.modal-body');
        if (this.element.dataset.filterRemoved === 'true') {
          this.searchDisabled()
        }
        if (modalBody.length) {
          const originalOverflow = modalBody.data('original-overflow') || 'auto';
          modalBody.css('overflow', originalOverflow);
        }
      })
      .on('select2:select', (e) => {
        // Clear the search input
        const searchInput = document.querySelector('.select2-container--open .select2-search__field');
        if (searchInput) {
          searchInput.value = "";
          searchInput.dispatchEvent(new Event("input", { bubbles: true }));
        }

        this.element.dispatchEvent(new Event("change", { bubbles: true }));
        if (this.hasSelectAnalyticsTarget) {
          this.handleSubmitSelection(e)
          return;
        }
        if (this.hasMoveFolderTarget) {
          this.handleFolderSelection(e)
          return;
        }
        if (this.element.dataset.analyticsChart === "true") {
          this.handleUpdateChart();
          return;
        }
        if (this.hasSelectInterestTarget) {
          this.fetchData();
        }
      })
      .on('select2:selecting', (e) => {
        const maxSelection = parseInt(this.element.dataset.maxSelection, 10);
        if (!maxSelection) return;

        const selectedValues = $(this.element).val() || [];
        if (selectedValues.length >= maxSelection) {
          e.preventDefault();

          const errorElement = document.querySelector(".language_error");
          if (!errorElement) return;

          errorElement.innerHTML = `You can select up to ${maxSelection} languages.`;
          setTimeout(() => {
            $(this.element).select2("close");
          }, 0);
        }
      })
      .on('select2:unselect', (e) => {
        const maxSelection = parseInt(this.element.dataset.maxSelection, 10);
        const selectedValues = $(this.element).val() || [];

        if (selectedValues.length < maxSelection) {
          const errorElement = document.querySelector(".language_error");
          if (errorElement) {
            errorElement.innerHTML = "";
          }
        }
        this.element.dispatchEvent(new Event("change", { bubbles: true }));
        if (this.hasSelectAnalyticsTarget) {
          this.handleSubmitSelection(e)
          return;
        }
        if (this.element.dataset.analyticsChart === "true") {
          this.handleUpdateChart();
          return;
        }
        if (this.hasSelectInterestTarget) {
          this.fetchData();
        }
      });
  }

  handleSubmitSelection(e) {
    const value = e.target.value
    const url = new URL(this.element.dataset.url, globalThis.location.origin)
    url.searchParams.set("range", value)

    fetch(url, {
      method: 'get',
      headers: {
        'Accept': "text/vnd.turbo-stream.html"
      }
    })
      .then(r => r.text())
      .then(html => Turbo.renderStreamMessage(html));
  }

  handleUpdateChart() {
    const status = document.getElementById("analytics-bar-status")?.value
    const year = document.getElementById("analytics-bar-details")?.value
    const url = new URL(this.element.dataset.url, globalThis.location.origin)

    url.searchParams.set("year", year)
    url.searchParams.set("status", status)

    fetch(url, {
      method: 'get',
      headers: {
        'Accept': "text/vnd.turbo-stream.html"
      }
    })
      .then(r => r.text())
      .then(html => Turbo.renderStreamMessage(html));
  }

  handleFolderSelection(e) {
    let form = $(this.element).closest('form')
    form[0].requestSubmit()
  }

  fetchData() {
    // remove the selected option from select field and show the placeholder again
    $('.select2-selection__choice').remove();
    $('.select2-search__field').attr('placeholder', 'Select Interest').removeAttr('style');

    let form = $(this.element).closest('form')
    form[0].requestSubmit()
  }

  searchDisabled() {
    const searchTextarea = document.querySelector('.select2-search__field');
    searchTextarea.setAttribute('disabled', 'disabled');
  }

}
